export const getCarIcon = (vehicleWeightUnladen?: number) => {
  if (vehicleWeightUnladen === undefined) {
    return "auto";
  }

  if (vehicleWeightUnladen < 3500) {
    return "car";
  }
  if (vehicleWeightUnladen > 3500 && vehicleWeightUnladen < 5000) {
    return "boxTruck";
  }
  return "auto";
};
